import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=6b4c45a0&scoped=true&"
import script from "./Cases.vue?vue&type=script&lang=ts&"
export * from "./Cases.vue?vue&type=script&lang=ts&"
import style0 from "./Cases.vue?vue&type=style&index=0&id=6b4c45a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c45a0",
  null
  
)

export default component.exports